var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0677 5.75121L7.83457 1.28178C7.6356 1.14276 7.36701 1.14121 7.16578 1.28178L0.932675 5.75121C0.303632 6.20223 -0.379655 5.25132 0.250324 4.79959L6.48586 0.32847C6.48723 0.327475 6.48861 0.326509 6.49002 0.325514C7.09186 -0.0982001 7.90152 -0.103177 8.51043 0.325514C8.5118 0.32648 8.51321 0.327475 8.51458 0.32847L14.7501 4.79959C15.3813 5.25223 14.6913 6.19837 14.0677 5.75121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.067 14.9947H8.67118C8.34781 14.9947 8.08569 14.7326 8.08569 14.4092V12.0673C8.08569 11.7445 7.82305 11.4818 7.50021 11.4818C7.17738 11.4818 6.91473 11.7445 6.91473 12.0673V14.4092C6.91473 14.7326 6.65261 14.9947 6.32925 14.9947H2.93345C1.96494 14.9947 1.177 14.2068 1.177 13.2383V7.98671C1.177 7.41715 1.45446 6.88132 1.91936 6.55257L6.48434 3.25724C6.48621 3.25586 6.48812 3.25452 6.49005 3.25317C7.0919 2.82957 7.90141 2.82457 8.51037 3.25317C8.51228 3.25452 8.51418 3.25586 8.51608 3.25724L13.0811 6.5526C13.546 6.88135 13.8235 7.41718 13.8235 7.98674V13.2383C13.8234 14.2068 13.0355 14.9947 12.067 14.9947ZM9.25666 13.8238H12.067C12.3898 13.8238 12.6525 13.5611 12.6525 13.2383V7.98671C12.6525 7.79643 12.5596 7.61744 12.4039 7.50793C12.402 7.50658 12.4001 7.50524 12.3982 7.50386L7.83408 4.20912C7.63499 4.07042 7.36701 4.06933 7.16634 4.20912L2.60218 7.50386C2.60031 7.50521 2.59841 7.50658 2.59647 7.50793C2.44088 7.61744 2.34797 7.79643 2.34797 7.98671V13.2383C2.34797 13.5611 2.61061 13.8238 2.93345 13.8238H5.74376V12.0673C5.74376 11.0988 6.53171 10.3109 7.50021 10.3109C8.46872 10.3109 9.25666 11.0988 9.25666 12.0673V13.8238Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d89245bf110d9d69bd070304ec652ae1.svg";
export { ForwardRef as ReactComponent };